import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../assets/styles/mixins.scss';

const useSyllabusStyles = makeStyles({
  uploadedFileIcon: {
    fontSize: 48,
    color: '#fff'
  },
  uploadIcon: {
    fontSize: 48,
    color: '#fff'
  },
  fileError: {
    color: mixins.swatchDanger,
    marginTop: 12
  },
  uploadedFileName: {
    marginBottom: 4,
    wordBreak: 'break-all'
  },
  uploadBoxActive: {
    borderColor: '#ffd966',
    background: 'rgba(255,217,102,0.08)'
  },
  header: {
    marginBottom: 16,
    color: mixins.chalkWhiteFont
  },
  back: {
    cursor: 'pointer',
    color: mixins.chalkWhiteFont
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    flex: '1 0 0',
    padding: 20
  },
  iconBox: {
    borderRadius: '50%',
    width: 80,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    boxSizing: 'border-box'
  },
  progressDeterminate: {
    backgroundColor: '#E0E0E0', // Background color for remaining portion
    '& .MuiLinearProgress-bar': {
      backgroundColor: mixins.amethyst // Color for uploaded portion
    }
  },
  progressBar: {
    backgroundColor: mixins.amethyst // Color for uploaded portion
  },
  progressRoot: {
    flexGrow: 1,
    height: 4,
    borderRadius: 4,
    marginRight: 12,
    width: '100%'
  },
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: 24
  },
  progressText: {
    color: mixins.blackColor
  },
  progressTextItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 8,
    minWidth: 300,
    position: 'relative',
    paddingLeft: 26 // Reserve space for tick icon (18px + 8px margin)
  },
  deleteIcon: {
    color: mixins.navyColor
  },
  deleteIconContainer: {
    position: 'relative',
    top: '-128px',
    left: '50%'
  },
  progressTextsContainer: {
    marginBottom: 16,
    minHeight: 120,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    width: '100%'
  },
  checkIcon: {
    color: mixins.accentGreen,
    fontSize: 18,
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  percent: {
    marginBottom: 0,
    minWidth: 40,
    textAlign: 'right',
    alignSelf: 'end',
    display: 'flex'
  },
  title: {
    marginBottom: 12
  },
  desc: {
    marginBottom: 32
  },
  uploadBox: {
    border: `2px dashed ${mixins.amethyst}`,
    borderRadius: 16,
    padding: '64px 32px',
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    justifyContent: 'center',
    minHeight: 263
  },
  uploadDragText: {
    color: mixins.color_text_primary,
    fontSize: 20,
    fontWeight: 500
  },
  uploadDragContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 8
  },
  uploadDragIcon: {
    fontSize: 28,
    color: mixins.color_text_primary,
    verticalAlign: 'middle'
  },
  root: {
    width: '100%',
    backgroundColor: mixins.chalkWhiteFont,
    padding: 16,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: 12,
    alignSelf: 'stretch',
    gap: 16,
    height: '100%'
  },
  contentWrapper: {
    width: '100%',
    flex: 1,
    minHeight: 0
  },
  tabsContainer: {
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    minHeight: 0,
    marginBottom: 8,
    '&.hidden': {
      visibility: 'hidden',
      height: 0
    },
    '& .MuiTabs-indicator': {
      visibility: 'hidden'
    }
  },
  tab: {
    display: 'flex',
    height: 42,
    padding: '8px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    width: 184,
    gap: 2,
    flex: '1 1 0',
    borderRadius: 8,
    minHeight: 42,
    boxSizing: 'border-box',
    fontWeight: `${mixins.fontWeight500} !important`,
    fontFamily: `${mixins.fontFamilyPlusSans} !important`,
    lineHeight: '100%',
    fontSize: `${mixins.fontSize14} !important`,
    '&.Mui-selected': {
      backgroundColor: mixins.chalkWhiteFont
    }
  },
  tabPanel: {
    width: '100%',
    flexGrow: 1
  },
  ctaSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: '16px 0px'
  },
  hideConfirmButton: {
    '& button': {
      visibility: 'hidden'
    }
  },
  uploadButton: {
    backgroundColor: mixins.amethyst,
    color: mixins.chalkWhiteFont,
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: 500,
    textTransform: 'none',
    fontFamily: mixins.fontFamilyPlusSans,
    height: 40,
    borderRadius: 1000,
    width: 97,
    '&:hover': {
      background: mixins.amethyst,
      color: mixins.chalkWhiteFont
    }
  },
  bulkEditCtaButton: {
    visibility: 'visible !important',
    width: 97,
    height: 40,
    borderRadius: 1000,
    backgroundColor: mixins.amethyst,
    padding: '0px 8px 2px 8px',
    gap: 16,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    fontWeight: mixins.fontWeight500,
    lineHeight: '22px',
    minWidth: 103,
    '&:hover': {
      boxShadow: 'none',
      background: mixins.amethyst,
      color: mixins.chalkWhiteFont
    }
  },
  footerText: {
    color: mixins.greyScaleColor,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 12,
    textAlign: 'center',
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px'
  },
  bulkEditHelpText1: {
    fontFamily: mixins.fontFamilyPlusSans
  },
  bulkEditHelpText2: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight700
  },
  bulkEditHelpTextContainer: {
    display: 'flex',
    gap: 8,
    flexDirection: 'column',
    padding: '14px 0px'
  },
  syllabusUploadTabs: {
    display: 'flex',
    alignItems: 'flex-start',
    maxWidth: 368,
    height: 50,
    padding: 4,
    backgroundColor: '#E5E0F3',
    borderRadius: 12,
    boxSizing: 'border-box'
  },
  bulkEditCtaButtonDisabled: {
    color: mixins.bulkEditCtaButtonDisabledColor,
    backgroundColor: mixins.bulkEditCtaButtonDisabledBGColor,
    cursor: 'default',
    '&:hover': {
      background: mixins.bulkEditCtaButtonDisabledBGColor,
      color: mixins.bulkEditCtaButtonDisabledColor
    }
  },
  hideTab: {
    display: 'none'
  },
  footer: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center'
  }
});

export default useSyllabusStyles;
